import React from "react";
import { FieldRendererProps } from "../types";
import { StyledLabelTitle, StyledSubLabel } from "../styles";

export const LabelFieldRenderer: React.FC<FieldRendererProps> = ({ campo }) => (
  <>
    <StyledLabelTitle bold>{campo.label}</StyledLabelTitle>
    {campo.subLabel && <StyledSubLabel>{campo.subLabel}</StyledSubLabel>}
  </>
);
